<template>
  <v-dialog max-width="480" v-model="dialog" persistent outlined>
    <v-card class="text-center">
      <v-card-title class="justify-center">
        <v-icon color="warning" size="86">mdi-alert-circle</v-icon>
      </v-card-title>
      <v-card-title class="headline justify-center">
        <span style="word-break: normal">{{ errorMessage }}</span>
      </v-card-title>

      <v-col cols="12" align-self="center" justify="center" align="center">
        <v-card flat class="pb-5 buttons">
          <v-btn
            color="primary"
            depressed
            block
            large
            class="mt-3 primary-font-color"
            @click="onHomeBtnClick()"
          >
            <div>{{ $translate('BACK_HOME_PAGE') }}</div>
          </v-btn>
        </v-card>
      </v-col>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ErrorDialog',
  props: {
    dialog: Boolean,
    errorMessage: String,
  },

  data() {
    return {};
  },
  methods: {
    onHomeBtnClick() {
      this.$router.push({
        name: 'Homepage',
        params: {
          account_id: this.$store.getters.getRegion,
        },
      });
    },
  },
};
</script>
